/**
 * Къде да се върне родителят след вход — адресът, който е поискал, преди `PrivateRoute` да го
 * прати на `/login`.
 *
 * До 19.10.2026 входът водеше всеки родител на таблото: пряката връзка
 * `/assignments?assignmentId=…` губеше формата за подпис, ако родителят не е бил влязъл.
 *
 * 🔴 Само път ВЪТРЕ в приложението и само от `location.state` (React Router), никога от адреса —
 * параметър в URL-а би бил отворено пренасочване. `//host` е външен адрес за браузъра → отказ.
 * Админските и учителските пътища не се връщат: родителят там няма достъп.
 */
export function returnPathFrom(state: unknown): string | null {
  const from = (state as { from?: { pathname?: unknown; search?: unknown; hash?: unknown } } | null)?.from;
  const pathname = from?.pathname;
  if (typeof pathname !== 'string' || !pathname.startsWith('/') || pathname.startsWith('//')) return null;
  if (pathname === '/login' || /^\/(admin|teacher)(\/|$)/.test(pathname)) return null;
  const search = typeof from?.search === 'string' ? from.search : '';
  const hash = typeof from?.hash === 'string' ? from.hash : '';
  return pathname + search + hash;
}
